export const search = {
    namespaced: true,
    state:{
        searchTerm: ""
    },
    getters:{
        getSearchTerm(state){
            return state.searchTerm
        }
    },
    mutations:{
        updateSearchTerm(state, searchTerm){        
            state.searchTerm = searchTerm;
        },

          removeSearchTerm(state){        
            state.searchTerm = "";
        },
      
  
    },
    actions: {
        updateSearchTerm({commit}, data){
            commit('updateSearchTerm', data)
        },
         removeSearchTerm({commit}){
            commit('removeSearchTerm', data)
        }
    }
}